export default "__VITE_ASSET__b2c3e20b__"